import { ACTIONS } from './auth.actions';
import { z } from 'zod';

export const AuthUserSchema = z.object({
  id: z.number(),
  name: z.string(),
  access: z.string(),
  refresh: z.string(),
  is_superuser: z.boolean(),
  area_leader: z.array(z.number()).optional(),
});

export type AuthUser = z.infer<typeof AuthUserSchema>;

export type AuthActions = {
  type: ACTIONS;
  user?: AuthUser | undefined;
  permissions?: Array<string>;
  area_leader?: number[];
};

export type AuthState = {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: AuthUser | undefined;
  dispatch: (obj: AuthActions) => void;
  permissions?: Array<string> | null;
  area_leader?: number[] | null;
};
